import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, ValidatorFn } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { StatusService } from 'src/app/core/services/status/status.service';
import { Utils } from 'src/app/shared/utils/utils';
import { IBundle } from 'src/app/core/interfaces/shared/bundle/IBundle';
import { IObject } from 'src/app/core/interfaces/response/IObject';

@Component({
    selector: 'advanced-checkbox',
    templateUrl: './advanced-checkbox.component.html',
    styleUrls: ['./advanced-checkbox.component.scss'],
    providers: [CurrencyPipe]
})
export class AdvancedCheckboxComponent {

    form: FormGroup;
    status: IBundle;

    @Output()
    formLoaded: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

    @Input() genericData;

    _listItems: IObject[] = [];

    @Input()

    set listItems(value: IObject[]) {
        this._listItems = value;
        if (this._listItems) {
            this.form = this.createFormGroups();
        }
    }

    get listItems(): IObject[] {
        return this._listItems;
    }

    get value() {
        return this.form.value;
    }

    get sumOfAllValues(): number {
        let sum = 0;
        if (this.form) {
            Object.values(this.form.controls).forEach((group: FormGroup) => {
                sum += isNaN(+Utils.StringToNumber(group.value.value)) ? 0 : +Utils.StringToNumber(group.value.value);
            });
        }
        return sum;
    }

    constructor(private fb: FormBuilder, private statusService: StatusService) {
        this.status = statusService.getCurrentObject();
    }

    createFormGroups(): FormGroup {

        const group = this.fb.group({});

        this._listItems.forEach(object => {

            const control = this.fb.group({
                id: object.id,
                alias: object.descripcion,
                descripcion: object.descripcion,
                value: [object.value],
                porcentajeTotal: object.porcentajeTotal
            });

            group.addControl(object.id.toString(), control);

        });

        this.formLoaded.emit(group);
        
        return group;
    }


    getlight(item: IObject) {

        if (!this.form) return false;

        const form = this.form.controls[item.id] as FormGroup;
        const value_control = form.controls['value'];

        if (value_control.value <= 0) {
            value_control.setValue(+Utils.StringToNumber(value_control.value));
        }
        
        return value_control.value > 0;
    }
}
